// AD-151: file format from the real mime when we have one (data URLs), the
// extension otherwise — shown on library thumbnails and used to gate the
// "Add background" button.
export const detectImageFormat = (src) => {
    if (!src || typeof src !== 'string') return null;
    if (src.startsWith('data:')) {
        const mime = src.slice(5, src.indexOf(';') > 0 ? src.indexOf(';') : src.indexOf(',')).toLowerCase();
        if (mime.includes('svg')) return 'SVG';
        if (mime === 'image/png') return 'PNG';
        if (mime === 'image/jpeg' || mime === 'image/jpg') return 'JPG';
        if (mime === 'image/webp') return 'WEBP';
        if (mime === 'image/gif') return 'GIF';
        return null;
    }
    const match = src.split('?')[0].toLowerCase().match(/\.(png|jpe?g|svg|webp|gif)$/);
    if (!match) return null;
    if (match[1] === 'svg') return 'SVG';
    if (match[1] === 'png') return 'PNG';
    if (match[1] === 'webp') return 'WEBP';
    if (match[1] === 'gif') return 'GIF';
    return 'JPG';
};
